import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.superModelState
    ? { ...initialState, ...state.superModelState }
    : initialState;

export const selectSuperModelManufacturerFilter = createSelector(
  [selectDomain],
  (superModelState) => superModelState.manufacturerFilter
);

export const selectSuperModelManufacturerOptions = createSelector(
  [selectDomain],
  (superModelState) => superModelState.manufacturerOptions ?? []
);

export const selectSuperModelManufacturerOptionsLoading = createSelector(
  [selectDomain],
  (superModelState) => superModelState.manufacturerOptionsLoading
);

export const selectSuperModelManufacturerOptionsError = createSelector(
  [selectDomain],
  (superModelState) => superModelState.manufacturerOptionsError
);

export const selectSuperModelsLoading = createSelector(
  [selectDomain],
  (superModelState) => superModelState.loading
);

export const selectSuperModelsList = createSelector(
  [selectDomain],
  (superModelState) => superModelState.list
);

export const selectSuperModelMeta = createSelector(
  [selectDomain],
  (superModelState) => superModelState.meta
);

export const selectSuperModelPage = createSelector(
  [selectDomain],
  (superModelState) => superModelState.page
);

export const selectSuperModelPerPage = createSelector(
  [selectDomain],
  (superModelState) => superModelState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (superModelState) => superModelState.isAddModalOpen
);

export const selectSuperModelForm = createSelector(
  [selectDomain],
  (superModelState) => superModelState.form
);

export const selectSuperModelFormDropDown = createSelector(
  [selectDomain],
  (superModelState) => superModelState.formDropDown
);

export const selectSuperModelSaving = createSelector(
  [selectDomain],
  (superModelState) => superModelState.saving
);

export const selectSuperModelDetail = createSelector(
  [selectDomain],
  (superModelState) => superModelState.detail
);

export const selectSuperModelDetailLoading = createSelector(
  [selectDomain],
  (superModelState) => superModelState.detailLoading
);

export const selectSuperModelDetailError = createSelector(
  [selectDomain],
  (superModelState) => superModelState.detailError
);
